module.exports = __webpack_public_path__ + "328de499bdf9530448d1c401ce2dbcaf.png";